import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& $cardLabel': {
        marginBottom: SMALL_MARGIN / 2,
        [theme.breakpoints.up('md')]: {
          marginBottom: SMALL_MARGIN,
        },
      },
    },
    cardLabel: {},
    title: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      fontSize: 24,
      lineHeight: '28px',
      marginBottom: SMALL_MARGIN / 2,
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        lineHeight: '34px',
        marginBottom: SMALL_MARGIN,
      },
    },
    description: {
      color: colorsPalette.gray,
      marginBottom: SMALL_MARGIN / 2,
      fontSize: 18,
      lineHeight: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '30px',
        marginBottom: SMALL_MARGIN,
      },
    },
    withDots: {
      '&:after': {
        content: '"..."',
      },
    },
    link: {
      color: colorsPalette.violet,
      fontSize: 18,
      lineHeight: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '30px',
      },
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }),
);

export default useStyles;
